export const checkrDashboardURI = 'https://dashboard.checkr.com';
export const stripe = 'https://api.stripe.com/v1';
export const GOOGLE_API_KEY = 'AIzaSyABp93ZCsRNFKtO93ISuDfya_gk90kYvLA';
export const firebaseConfig = {
  apiKey: 'AIzaSyCHcvOu7lFSQfmy67kY8O-8w4l8gEEiRlM',
  authDomain: 'gravy-1527701591983.firebaseapp.com',
  databaseURL: 'https://gravy-1527701591983.firebaseio.com',
  projectId: 'gravy-1527701591983',
  storageBucket: 'gravy-1527701591983.appspot.com',
  messagingSenderId: '754726480383'
};
export const firebaseKeyPair = 'BF6xtFuwlyO1AbICaf7zWPEmRU5z1YC2jskibcMp6kovIhLS2PEXRQnZanFxw-64_672BMbkE96CurcqbYzoihI';
export const appPath = 'app';



// WEBPACK FOOTER //
// ./src/constants/index.js